define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Rect = (function () {
        function Rect(x, y, width, height) {
            this.x = 0;
            this.y = 0;
            this.width = 0;
            this.height = 0;
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;
        }
        Rect.prototype.Copy = function (rect) {
            return new Rect(rect.x, rect.y, rect.width, rect.height);
        };
        return Rect;
    }());
    exports.Rect = Rect;
});
//# sourceMappingURL=Rect.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Shared/Rect.js
// module id = 163
// module chunks = 0